import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { CrudService } from '@ml/shared/services/crud.service';
import { combineLatest, defer, from, of } from 'rxjs';
import { catchError, filter, map, switchMap, tap } from 'rxjs/operators';
import { ConnectionService } from '@ml/core/services/connection.service';
import { UserService } from '@ml/core/services';
import { TaskIDBService } from '@ml/tasks/services/task-idb.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./task-idb.service";
import * as i3 from "../../core/services/connection.service";
import * as i4 from "../../core/services/user.service";
var TaskLogsService = /** @class */ (function (_super) {
    tslib_1.__extends(TaskLogsService, _super);
    function TaskLogsService(http, taskLogsIDB, connectionService, userService) {
        var _this = _super.call(this, http, false) || this;
        _this.http = http;
        _this.taskLogsIDB = taskLogsIDB;
        _this.connectionService = connectionService;
        _this.userService = userService;
        return _this;
    }
    TaskLogsService.prototype.setTask = function (task) {
        this.task = task;
    };
    Object.defineProperty(TaskLogsService.prototype, "url", {
        get: function () {
            return "tasks/" + this.task.id + "/logs";
        },
        enumerable: true,
        configurable: true
    });
    TaskLogsService.prototype.getAll = function (queryParams) {
        return this.http
            .get("task-logs", {
            params: queryParams
        })
            .pipe(catchError(function (error) { return of([]); }));
    };
    TaskLogsService.prototype.list = function () {
        var _this = this;
        return this._http.get(this.url).pipe(catchError(function (error) { return of([]); }), switchMap(function (values) { return _this.mergeLogs(values); }), switchMap(function (values) {
            _this.values$.next(values);
            return _this.values$;
        }));
    };
    TaskLogsService.prototype.add = function (value) {
        var _this = this;
        /**
         * If there is no connection we need to add the log in local storage
         */
        var addObservable = null;
        if (!this.connectionService.connection) {
            addObservable = this.createLocalTaskLog(value);
        }
        else {
            addObservable = this.addRequest(value);
        }
        return addObservable.pipe(tap(function (_value) { return _this.addValue(_value); }));
    };
    TaskLogsService.prototype.stop = function (taskLog, extraInformation, taskLogMeasurements) {
        var _this = this;
        /**
         * If there is no  internet store the request on idb
         */
        var body = {};
        if (extraInformation) {
            body.extraInformation = extraInformation;
        }
        if (taskLogMeasurements) {
            body.measurementUnits = taskLogMeasurements;
        }
        var stopObservable = null;
        if (!this.connectionService.connection) {
            // if there is no internet store the task log to `idb` database
            stopObservable = this.stopLocalTaskLog(taskLog, body);
        }
        else {
            stopObservable = this.stopRequest(taskLog.id, body);
        }
        return stopObservable.pipe(tap(function (_value) { return _this.updateValue(taskLog, _value); }));
    };
    TaskLogsService.prototype.submitCachedLogs = function () {
        var _this = this;
        var stoppedLogs$ = this.getCachedStoppedLogs();
        var cachedLogs$ = this.getCachedLogs();
        return combineLatest([cachedLogs$, stoppedLogs$]).pipe(map(function (_a) {
            var _cachedLogs = _a[0], _stoppedLogs = _a[1];
            var cachedLogs = _cachedLogs.map(function (value) {
                delete value.id;
                value.taskId = value.task.id;
                value.employee = value.employee.id;
                return value;
            });
            return [cachedLogs, _stoppedLogs];
        }), filter(function (_a) {
            var _cachedLogs = _a[0], _stoppedLogs = _a[1];
            return _cachedLogs.length > 0 || _stoppedLogs.length > 0;
        }), switchMap(function (_a) {
            var _cachedLogs = _a[0], _stoppedLogs = _a[1];
            var submittedBulkLogs = _cachedLogs.length > 0 ? _this.submitBulkLogs(_cachedLogs) : of([]);
            var submittedBulkStopLogs = _stoppedLogs.length > 0
                ? _this.submitBulkStoppedLogs(_stoppedLogs)
                : of([]);
            return combineLatest([submittedBulkLogs, submittedBulkStopLogs]);
        }), switchMap(function () {
            var clearLogs = _this.removeCachedLogs();
            var clearStopLogs = _this.removeStopCachedLogs();
            return combineLatest([clearLogs, clearStopLogs]);
        }));
    };
    TaskLogsService.prototype.submitBulkStoppedLogs = function (logs) {
        return this.http.post("task-logs/bulk-stop", logs);
    };
    TaskLogsService.prototype.submitBulkLogs = function (logs) {
        return this.http.post("task-logs/bulk", logs);
    };
    Object.defineProperty(TaskLogsService.prototype, "currentTaskLog$", {
        get: function () {
            return this.values$.pipe(map(function (values) { return (values ? values.find(function (value) { return !value.end; }) : null); }));
        },
        enumerable: true,
        configurable: true
    });
    TaskLogsService.prototype.stopRequest = function (taskLogId, body) {
        return this.http.patch(this.url + "/" + taskLogId + "/stop", body);
    };
    TaskLogsService.prototype.mergeLogs = function (logs) {
        var stoppedLogs = this.getCachedStoppedLogs();
        var cachedLogs = this.getCachedLogs();
        return combineLatest([cachedLogs, stoppedLogs]).pipe(map(function (_a) {
            var _cachedLogs = _a[0], _stoppedLogs = _a[1];
            var _loop_1 = function (log) {
                var stoppedLog = _stoppedLogs.find(function (value) { return value.id === log.id; });
                if (stoppedLog) {
                    log.end = stoppedLog.end;
                    log.extraInformation = stoppedLog.extraInformation;
                    log.measurementUnits = stoppedLog.measurementUnits;
                }
            };
            for (var _i = 0, logs_1 = logs; _i < logs_1.length; _i++) {
                var log = logs_1[_i];
                _loop_1(log);
            }
            return logs.concat(_cachedLogs);
        }));
    };
    TaskLogsService.prototype.removeCachedLogs = function () {
        var promise = this.taskLogsIDB
            .idbContext()
            .then(function (db) { return db.clear(TaskIDBService.dbLogsTable); });
        return from(promise);
    };
    TaskLogsService.prototype.removeStopCachedLogs = function () {
        var promise = this.taskLogsIDB
            .idbContext()
            .then(function (db) { return db.clear(TaskIDBService.dbStopLogsTable); });
        return from(promise);
    };
    TaskLogsService.prototype.getCachedStoppedLogs = function () {
        var stoppedLogs = this.taskLogsIDB
            .idbContext()
            .then(function (db) { return db.getAll(TaskIDBService.dbStopLogsTable); })
            .then(function (values) { return values || []; });
        return from(stoppedLogs);
    };
    TaskLogsService.prototype.getCachedLogs = function () {
        var logs = this.taskLogsIDB
            .idbContext()
            .then(function (db) { return db.getAll(TaskIDBService.dbLogsTable); })
            .then(function (values) { return values || []; });
        return from(logs);
    };
    TaskLogsService.prototype.stopLocalTaskLog = function (taskLog, body) {
        var _taskLog = this.taskLogsIDB.stopLog(taskLog, body);
        return defer(function () { return _taskLog; });
    };
    TaskLogsService.prototype.createLocalTaskLog = function (taskLog) {
        taskLog.task = this.task;
        taskLog.employee = this.userService.user;
        var _taskLog = this.taskLogsIDB.saveLog(taskLog);
        return defer(function () { return _taskLog; });
    };
    TaskLogsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TaskLogsService_Factory() { return new TaskLogsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.TaskIDBService), i0.ɵɵinject(i3.ConnectionService), i0.ɵɵinject(i4.UserService)); }, token: TaskLogsService, providedIn: "root" });
    return TaskLogsService;
}(CrudService));
export { TaskLogsService };
